import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { sendApi } from "../../apis/Index";

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Please enter the admin password");
      return;
    }

    setLoading(true);
    try {
      const response = await sendApi(
        { password },
        "https://wittynailtip.com/backend/admin-auth.php"
      );
      if (response.data.success) {
        toast.success("Admin access granted!");
        onLoginSuccess();
      } else {
        toast.error(response.data.message || "Invalid password");
      }
    } catch (error) {
      toast.error("An error occurred during login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 flex flex-col items-center justify-center font-jost p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-sm p-8 border border-gray-100">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-[#fff1f5] rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Admin Portal</h2>
          <p className="text-gray-500 text-sm mt-2">Enter secret key to access</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <input
              type="password"
              placeholder="Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#FFB7CF] focus:ring-2 focus:ring-[#FFB7CF]/20 outline-none transition-all"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FFB7CF] hover:bg-[#ff9cbb] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-50"
          >
            {loading ? "Authenticating..." : "Access Dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
